import React from 'react';
import classnames from 'classnames';
import style from './caption.scss';

const comparator = (compareTo: CAPTION_COLOR) => (
  val: CAPTION_COLOR,
): boolean => val === compareTo;

type CAPTION_COLOR =
  | 'yellow'
  | 'red'
  | 'turquoise'
  | 'green'
  | 'blue'
  | 'dark'
  | 'purple'
  | 'light'
  | 'orange'
  | 'dark-blue';

interface CaptionProps {
  color?: CAPTION_COLOR;
  children: React.ReactNode;
  className?: string;
  tagName?: string;
  dataHook?: string;
}

export const Caption = ({
  color = 'dark',
  children,
  className = '',
  tagName = 'span',
  dataHook,
}: CaptionProps) => {
  const getClassNames = () =>
    classnames({
      [style.caption]: true,
      [style.yellow]: comparator('yellow')(color),
      [style.red]: comparator('red')(color),
      [style.turquoise]: comparator('turquoise')(color),
      [style.green]: comparator('green')(color),
      [style.blue]: comparator('blue')(color),
      [style.purple]: comparator('purple')(color),
      [style.orange]: comparator('orange')(color),
      [style.darkBlue]: comparator('dark-blue')(color),
      [style.light]: comparator('light')(color),
    });

  return React.createElement(
    tagName,
    {
      'data-hook': dataHook,
      className: `${getClassNames()} ${className}`,
    },
    children,
  );
};
